if (posthog.getFeatureFlag('ad-08-air-purifier-collection-page-layout-mobile') === 'test') {
    (function () {
	function init() {
		document.querySelector('.product-grid-slider.section-overlay').insertAdjacentHTML(
			'afterbegin',
			`<div>
    <div>
        <div class="image-wrapper">
            <img class="ad-img" src="https://t90132510339.p.clickup-attachments.com/t90132510339/01215516-d67d-469a-a0d4-38eef44af0cc/image%20124.png" alt="Airdog Purifiers">
            
            <div class="text-content">
                <h1>Purifiers for every space. Never replace the filter</h1>
                <h2>Patented TPA® technology that destroys pollutants 20x smaller than HEPA in every size, for every room.</h2>
            </div>
        </div>
    </div>
</div>`,
		);
	}

	console.log(
		'%cAD-08 | Air Purifier Collection Page Layout (Mobile)',
		"color: white; background-color:#202621; font-weight: bold; font-family:'SpaceGrotesk', sans-serif;",
	);

	function poll(sel, cb) {
		setTimeout(function () {
			if (document.querySelector(sel)) cb();
			else poll(sel, cb);
		}, 50);
	}

	poll('.product-grid-slider', init);
})();

(function () {
	// 1. Mobile-only execution check
	if (window.innerWidth > 768) return;

	// 2. Filter Array Mapping
	// Note: "airdog pet air purifier" prevents accidentally matching the "P50 Pet"
	// "x5" will successfully match both "X5" and "X5+"
	const filterMapping = [
		{ label: 'All Products', match: [] },
		{ label: '< 860 sq ft', match: ['aircap', 'x3'] },
		{ label: '< 1,300 sq ft', match: ['p50'] },
		{ label: '< 1,600 sq ft', match: ['x5', 'airdog pet air purifier'] },
		{ label: '≤ 4,000 sq ft', match: ['x8'] },
	];

	function injectCSS() {
		if (document.getElementById('ab-test-styles')) return;
		const style = document.createElement('style');
		style.id = 'ab-test-styles';
		style.innerHTML = `
      @media (max-width: 768px) {
        .ad-img {
	width: 100%;
}

.product-product-wrapper {
	padding-left: 0 !important;
}

.product-grid-slider.section-overlay > .page-width > .section-heading {
	display: none !important;
}

.product-grid-slider.section-overlay,
.product-grid-slider.section-overlay {
	padding-top: 0 !important;
}

.product-product-wrapper.page-width {
	margin-top: 0 !important;
	transform: translateY(-10px);
}

.text-content {
	position: absolute;
	top: 0;
}

.text-content > h1,
.text-content > h2 {
	color: white !important;
}
.image-wrapper img {
	filter: brightness(0.6); /* 0 is pitch black, 1 is normal brightness. Adjust to your liking! */
}

.text-content > h1 {
	margin-top: 40px;
}

.text-content > h2 {
	font-size: 18px;
}

/* 1. Ensure the wrapper is relative so absolute positioning works inside it */
.image-wrapper {
	position: relative;
	display: inline-block; /* Or block/flex depending on your layout needs */
	color: white; /* Ensures the text stands out against the black overlay */
	text-align: center;
}
        /* --- Wrapper Protection --- */
        .ab-test-container {
          width: 100%;
          max-width: 100vw;
          box-sizing: border-box;
          overflow: hidden; /* Hard stop for any horizontal stretching */
          margin-bottom: 20px;
          background-color: #fff; /* Blocks bleeding dark backgrounds from other sections */
          position: relative;
          z-index: 10;
        }

        .ab-hide-original {
          display: none !important;
        }

        /* --- Scrollable Filter Carousel --- */
        .ab-filter-carousel {
          display: flex;
          overflow-x: auto;
          gap: 10px;
          padding: 10px 15px 20px 15px;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
          -ms-overflow-style: none;
		          background-color: #bfbfbf;
        }
        .ab-filter-carousel::-webkit-scrollbar {
          display: none;
        }

        .ab-filter-btn {
          flex: 0 0 auto;
          padding: 8px 16px;
          background-color: #fff;
          border: 1px solid #ccc;
          border-radius: 6px;
          font-size: 14px;
          color: #333;
          cursor: pointer;
          white-space: nowrap;
          font-family: inherit;
          transition: all 0.2s ease;
        }
        .ab-filter-btn.ab-active {
          border-color: #000;
          font-weight: 600;
          color: #000;
          box-shadow: 0 0 0 1px #000;
        }

        /* --- 2-Column Product Grid --- */
        .ab-product-grid {
          display: grid;
          /* minmax(0, 1fr) is the CRITICAL fix that stops images from breaking the grid width */
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 15px;
          padding: 15px;
          width: 100%;
          box-sizing: border-box;
        }

        /* Cleaned Cloned Item Styles */
        .ab-product-item {
          display: flex !important;
          flex-direction: column !important;
          width: 100% !important;
          min-width: 0 !important; /* Critical to prevent Grid blowouts from long text */
          margin: 0 !important;
          box-sizing: border-box;
          
          /* Overrides Swiper's hidden slide states */
          opacity: 1 !important;
          visibility: visible !important;
        }

        /* Overrides inline HTML width="400" attributes so images scale gracefully */
        .ab-product-item .product-image-container,
        .ab-product-item .product-image-container img {
          width: 100% !important;
          max-width: 100% !important;
          height: auto !important;
          object-fit: contain !important;
          display: block;
        }

        .ab-product-item .product-card-clickable-wrapper {
          display: flex !important;
          flex-direction: column;
          height: 100%;
          min-width: 0;
        }

        .ab-product-item .product-slider_content {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          min-width: 0;
        }

        /* Force long titles/prices to wrap instead of stretching columns */
        .ab-product-item * {
          white-space: normal !important;
          word-wrap: break-word !important;
        }

        /* Push "Shop Now" button firmly to the bottom */
        .ab-product-item .cart_button {
          margin-top: auto !important; 
        }

        .ab-hidden {
          display: none !important;
        }
      }

      /* Desktop Fallback */
      @media (min-width: 769px) {
        .ab-test-container { display: none !important; }
      }
    `;
		document.head.appendChild(style);
	}

	function initTest() {
		const originalWrapper = document.querySelector('.product-product-wrapper');
		const originalSlider = document.querySelector('.product-slider');
		const allSlides = document.querySelectorAll('.product-slider .product-item');

		if (!originalWrapper || !originalSlider || allSlides.length === 0 || document.getElementById('ab-mobile-test-wrapper')) return;

		// --- Deduplication Logic ---
		// Use a Map to grab exactly 1 of each unique product by URL.
		// This entirely bypasses Swiper's duplicate "ghost" slides.
		const uniqueProducts = new Map();
		allSlides.forEach((slide) => {
			const linkEl = slide.querySelector('a');
			if (linkEl && linkEl.href) {
				if (!uniqueProducts.has(linkEl.href)) {
					uniqueProducts.set(linkEl.href, slide);
				}
			}
		});

		if (uniqueProducts.size === 0) return;

		injectCSS();

		const testContainer = document.createElement('div');
		testContainer.id = 'ab-mobile-test-wrapper';
		testContainer.className = 'ab-test-container';

		const filterCarousel = document.createElement('div');
		filterCarousel.className = 'ab-filter-carousel';

		const productGrid = document.createElement('div');
		productGrid.className = 'ab-product-grid';

		// Clone and clean items
		uniqueProducts.forEach((slide) => {
			const clone = slide.cloneNode(true);

			// Strip Swiper classes so your theme stops hiding them, but keep your styling classes
			clone.classList.remove('swiper-slide', 'swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev', 'swiper-slide-duplicate');
			clone.classList.add('ab-product-item');

			// Remove inline styles injected by Swiper
			clone.removeAttribute('style');
			clone.removeAttribute('role');
			clone.removeAttribute('aria-label');

			productGrid.appendChild(clone);
		});

		// Build Filters
		filterMapping.forEach((filter, index) => {
			const btn = document.createElement('button');
			btn.className = 'ab-filter-btn';
			if (index === 0) btn.classList.add('ab-active');
			btn.innerText = filter.label;

			btn.addEventListener('click', () => {
				// Toggle Active Styling
				filterCarousel.querySelectorAll('.ab-filter-btn').forEach((b) => b.classList.remove('ab-active'));
				btn.classList.add('ab-active');

				// Filter cloned items
				const clonedItems = productGrid.querySelectorAll('.ab-product-item');
				clonedItems.forEach((item) => {
					if (filter.label === 'All Products') {
						item.classList.remove('ab-hidden');
						return;
					}

					const titleEl = item.querySelector('.product--title');
					const itemTitle = titleEl ? titleEl.textContent.trim().toLowerCase() : '';

					const isMatch = filter.match.some((mappedString) => itemTitle.includes(mappedString));

					if (isMatch) {
						item.classList.remove('ab-hidden');
					} else {
						item.classList.add('ab-hidden');
					}
				});
			});

			filterCarousel.appendChild(btn);
		});

		testContainer.appendChild(filterCarousel);
		testContainer.appendChild(productGrid);

		// Inject right before the original slider
		originalWrapper.insertBefore(testContainer, originalSlider);
		originalSlider.classList.add('ab-hide-original');
	}

	// Poll until elements exist
	let attempts = 0;
	const poll = setInterval(() => {
		if (document.querySelectorAll('.product-slider .product-item').length > 0) {
			clearInterval(poll);
			initTest();
		}
		if (++attempts > 50) clearInterval(poll);
	}, 100);
})();

} else {
    // It's a good idea to let control variant always be the default behaviour,
    // so if something goes wrong with flag evaluation, you don't break your app.
}